var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.177 96.355C27.121 96.355 26.262 95.496 26.262 94.44C26.262 93.384 27.121 92.525 28.177 92.525H47.1441L14.706 54.508C13.945 53.615 13.784 52.446 14.276 51.382C14.767 50.318 15.7601 49.683 16.9331 49.683H22.5111V6.57004C22.5111 4.95604 23.8241 3.64404 25.4371 3.64404H74.557C76.17 3.64404 77.483 4.95704 77.483 6.57004V49.683H83.066C84.238 49.683 85.2311 50.318 85.7221 51.382C86.2141 52.446 86.0531 53.615 85.2911 54.508L52.854 92.525H71.8171C72.8731 92.525 73.732 93.384 73.732 94.44C73.732 95.496 72.8731 96.355 71.8171 96.355H28.177ZM50 89.971L81.104 53.514H73.6521V7.47504H26.3421V53.514H18.8941L50 89.971Z",
    fill: "#0059F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8691 44.8531L56.0531 21.1541H60.1261L43.9421 44.8531H39.8691Z",
    fill: "#0059F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3062 45.216C55.6672 45.216 53.4072 42.83 53.4072 38.989C53.4072 35.208 55.7222 32.765 59.3062 32.765C62.8892 32.765 65.2032 35.208 65.2032 38.989C65.2032 42.831 62.9432 45.216 59.3062 45.216ZM59.3062 34.984C58.5702 34.984 56.8572 35.375 56.8572 38.989C56.8572 42.606 58.5702 42.997 59.3062 42.997C60.0412 42.997 61.7532 42.606 61.7532 38.989C61.7532 35.375 60.0412 34.984 59.3062 34.984Z",
    fill: "#0059F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.691 33.241C37.052 33.241 34.792 30.856 34.792 27.016C34.792 23.234 37.107 20.791 40.691 20.791C44.274 20.791 46.588 23.234 46.588 27.016C46.589 30.856 44.329 33.241 40.691 33.241ZM40.691 23.009C39.955 23.009 38.243 23.4 38.243 27.016C38.243 30.633 39.955 31.024 40.691 31.024C41.426 31.024 43.138 30.633 43.138 27.016C43.139 23.399 41.427 23.009 40.691 23.009Z",
    fill: "#0059F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e70ea78bcbf24fa7d54484cd3a4f37b3.svg";
export { ForwardRef as ReactComponent };